// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";
import { SavedSpellAspect } from "src/api/spells";

const metadata: BuiltInScriptMetadata = {
  name: "Ice Spike",
  id: "ice-spike",
  metadata: {
    aspect: SavedSpellAspect.Ice,
    imports: ["ice","vector","air","self"],
    icon: {
      "backgroundColor": 1649984,
      "layers": [
        {
          "iconKey": "iceBolt",
          "position": {
            "x": 0,
            "y": 0
          },
          "scale": 0.95,
          "rotation": -12,
          "color": 116459
        },
        {
          "iconKey": "air",
          "position": {
            "x": 15,
            "y": 1
          },
          "scale": 0.64,
          "rotation": -15,
          "color": 16646141
        }
      ]
    },
  },
};

export default metadata;
